import PropTypes from "prop-types";
import React from "react";
import { isEmpty } from "utils/general";

import useUser from "../../../services/apiUtils/hooks/useUser";
import { ProjectType } from "../../../types/propTypes";
import SearchAsYouType from "./searchAsYouType";

const UserSearchAsYouType = ({
    disabled = false,
    selectedValue,
    setSelectedValue,
    label,
    onlyActiveUsers = false,
}) => {
    const { getUserAutocomplete } = useUser();

    const autocompleteGet = (searchTerm, setOptions, setIsLoading) => {
        let newOptions = [];

        if (selectedValue) {
            newOptions = [selectedValue];
        }

        setIsLoading(true);

        getUserAutocomplete(searchTerm)
            .then((results) => {
                if (results) {
                    // Filtering Active and Inactive users
                    const filteredResults = onlyActiveUsers
                        ? results.filter((r) => r.is_active)
                        : results;
                    // Append results to options
                    newOptions = [...newOptions, ...filteredResults];
                }
                setOptions(newOptions);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <SearchAsYouType
            selectedValue={selectedValue}
            onSelectValue={setSelectedValue}
            isDisabled={disabled}
            autocompleteGet={autocompleteGet}
            searchPrompt={"Start typing to search for user's name or ID"}
            label={label}
            required
            isError={
                onlyActiveUsers &&
                !isEmpty(selectedValue?.NAME) &&
                !selectedValue?.is_active
            }
            optionKeyMapping={{
                label: "NAME",
            }}
        />
    );
};

UserSearchAsYouType.propTypes = {
    disabled: PropTypes.bool,
    selectedValue: ProjectType,
    setSelectedValue: PropTypes.func,
    label: PropTypes.string,
    onlyActiveUsers: PropTypes.bool,
};

export default UserSearchAsYouType;
